import { ResponseModel } from "@/Models/Utils/ResponseModel";
import { Delete, Get, Post, Put } from "../Request/Api";
import axios from "axios";
let config = {
  headers: {
    Authorization:
      "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjp7InVzZXJfZW1haWwiOiJoYW16YTU1NDU2MTNAZ21haWwuY29tIiwiYXBpX3Rva2VuIjoiT0IybU5QcFpScGcyV3ZLYkh6RHFrWExtc21paDZHSmZjSC1IYm42NjBjUl9jc2N0ZVV2eXg3c1ZqQ1o4d0lOTXRJUSJ9LCJleHAiOjE3MTEwMTcwMzV9.XN-KvrznodOXGs3Xl9xreT-ZkPvYTVyfBvnW3rpupcI",
    Accept: "application/json",
  },
};
export default {
  state: {
    studentIds: null,
    totalCost: null,
    ManualName: '',
    allRegions:[],
    allCountriesByRegionId:[],
    allStatesByCountryId:[],
    allCitiesByStateId:[],
    seminarId:null,
    courseName:null,
    Students:[],
    location: [],
    archivedLocation: [],
    seminars: [],
    filterOptionsData: [],
    SeminarsById: [],
    allCountriesByRegion: [],
    allStatesByCountry:[],
    allCitiesByState:[],
    regionName: "",
    seminarCourseName: null,
    seminarDate: null,
    seminarType: null,
    seminarStatus: "",
    seminarItemsPerPage: null,
    seminarPageno: null
  },
  getters: {
    GetStudents(state : any) {
      return state.Students;
    },
    GetAllCountriesByRegionId(state : any) {
      return state.allCountriesByRegionId;
    },
    GetAllCitiesByStateId(state : any) {
      return state.allCitiesByStateId;
    },
    GetAllStatesByCountryId(state : any) {
      return state.allStatesByCountryId;
    },
    GetAllRegions(state : any) {
      return state.allRegions;
    },
    GetSeminarById(state: any) {
      return state.SeminarsById;
    },
    GetLocation(state: any) {
      return state.location;
    },
    GetArchivedLocation(state: any) {
      return state.archivedLocation.Data;
    },
    GetSeminars(state: any) {
      return state.seminars.Data;
    },
    GetFilterOptionsData(state: any) {
      return state.filterOptionsData;
    },
  },
  actions: {
    async DeleteSeminar({ commit }: any, payload: any) {
      return await Delete(`Seminar/DeleteSeminar/${payload.Id}`).then((res) => {
        return res.data;
      });
    },
    async GetAllLocations({ commit }: any, payload: any) {
      return await Get(
        `Location/GetLocation/${payload.page}?userid=${payload.id}&pageSize=${payload.pageSize}&search=${payload.search}&filters=${payload.filters}`
      ).then((res: any) => {
        commit("SetLocation", res.data.Data.List);
        return res.data;
      });
    },
    async GetFiltersOptionsData({ commit }: any, id: number) {
      return await Get(`Location/GetLocationFiltersUserId?userId=${id}`).then(
        (res) => {
          commit("SetFiltersOptionsData", res.data);
        }
      );
    },
    async GetAllArchivedLocations({ commit }: any, payload: any) {
      return await Get(
        `Location/GetArchivedLocation?page=${payload.page}&userid=${payload.id}&pageSize=${payload.pageSize}&search=${payload.search}&filters=`
      ).then((res) => {
        commit("SetArchivedLocation", res.data);
      });
    },

    async AddLocation({ commit }: any, payload: any) {
      return await Post("Location/AddLocation", payload).then((res) => {
        return res.data;
      });
    },
    async AddLocationToArchive({ commit }: any, payload: any) {
      return await Put(
        `Location/ArchiveLocation?locationId=${payload}`,
        payload
      ).then((res) => {
        return res.data;
      });
    },
    async UnArchiveLocation({ commit }: any, payload: any) {
      return await Put(
        `Location/UnArchiveLocation?locationId=${payload}`,
        payload
      ).then((res) => {
        return res.data;
      });
    },
    async EditLocation({ commit }: any, payload: any) {
      return await Put("Location/EditLocation", payload).then((res) => {
        return res.data;
      });
    },
    async DeleteLocation({ commit }: any, payload: any) {
      return await Delete(`Location/DeleteLocation?locationId=${payload}`);
    },
    async AddSeminar({ commit }: any, payload: any) {
      return await Post("Seminar/AddSeminar", payload).then((res) => {
        return res.data;
      });
    },
    async EditSeminar({ commit }: any, payload: any) {
      return await Put("Seminar/EditSeminar", payload).then((res) => {
        return res.data;
      });
    },
    async GetSeminarById({ commit }: any, payload: any) {
      return await Get(`Seminar/GetSeminarById?id=${payload.Id}`).then(
        (res: any) => {
          commit("SetSeminarsById", res.data.Data);
          return res.data.Data.List;
        }
      );
    },
    async GetAllSeminars({ commit }: any, payload: any) {
      return await Get(
        `Seminar/GetAllSeminar/${payload.page}?pageSize=${payload.pageSize}&search=${payload.search}&filters=${payload.filters}`
      ).then((res: any) => {
        commit("SetSeminars", res.data);
        return res.data;
      });
    },
    async GetStudents({ commit } : any, payload : any) {
      return await Get(`Seminar/GetStudent?seminarId=${payload.Id}&page=${payload.page}&pageSize=${payload.pageSize}`).then((res:any) => {
        commit("SetStudents", res.data);
        return res.data.Data;
      });
    },
    async DeleteStudents({ commit } : any, payload : any) {
      return await Delete(`Seminar/DeleteStudent?studentId=${payload.Id}&seminarId=${payload.seminarId}`).then((res) => {
        return res.data;
      });
    },
    async GraduateStudents({ commit } : any, payload : any) {
      return await Post(`Seminar/GraduateStudents`, payload).then(
        (res) => {
          return res.data;
        }
      );
    },
    async AddStudent({ commit } : any, payload : any) {
      return await Post(`Seminar/AddStudents`, payload).then(
        (res) => {
          return res.data;
        }
      );
    },
    async SendEmailToStudents({ commit } : any, payload : any) {
      return await Post(`Seminar/SendEmailToStudents`, payload).then(
        (res) => {
          return res.data;
        }
      );
    },
    async GetAllRegions({ commit }: any, payload: any) {
      return await Get(`GeneralLocations/GetAllRegions`).then(
        (res: any) => {
          commit("SetAllRegions", res.data.Data);
          return res.data.Data.List;
        }
      );
    },
    async GetCountriesByRegionId({ commit }: any, payload: any) {
      return await Get(`GeneralLocations/GetCountriesByRegionId?Id=${payload}`).then(
        (res: any) => {
          commit("SetCountriesByRegionId", res.data.Data);
          return res.data.Data.List;
        }
      );
    },
    async GetStatesByCountryId({ commit }: any, payload: any) {
      return await Get(`GeneralLocations/GetStatesByCountryId?Id=${payload}`).then(
        (res: any) => {
          commit("SetStatesByCountryId", res.data.Data);
          return res.data.Data.List;
        }
      );
    },
    async GetCitiesByStateId({ commit }: any, payload: any) {
      return await Get(`GeneralLocations/GetCitiesByStateId?Id=${payload}`).then(
        (res: any) => {
          commit("SetCitiesByStateId", res.data.Data);
          return res.data.Data.List;
        }
      );
    },
    async PaySeminarManual({ commit }: any, payload: any) {
      return await Post("Seminar/PaySeminarManual", payload).then((res) => {
        return res.data;
      });
    },
  },
  mutations: {
    SetCitiesByStateId(state: any, payload: any) {
      state.allCitiesByStateId = payload;
    },
    SetCountriesByRegionId(state: any, payload: any) {
      state.allCountriesByRegionId = payload;
    },
    SetAllRegions(state: any, payload: any) {
      state.allRegions = payload;
    },
    SetStatesByCountryId(state: any, payload: any) {
      state.allStatesByCountryId = payload;
    },
    SetStudents(state: any, payload: any) {
      console.log("payload ",payload)
      state.Students = payload;
    },
    SetEnrolledCourseOrSeminarByUserId(state: any, payload: any) {
      state.EnrolledCourseOrSeminarByUserId = payload;
    },
    SetSeminarsById(state: any, payload: any) {
      state.SeminarsById = payload;
    },
    SetLocation(state: any, payload: any) {
      state.location = payload;
    },
    SetArchivedLocation(state: any, payload: any) {
      state.archivedLocation = payload;
    },
    SetSeminars(state: any, payload: any) {
      payload.Data.List.forEach((item:any)=>{
      const validDate = item.SeminarDateAndTimes.find((date:any) => {
        const seminarDate = new Date(date.Date);
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);
        return seminarDate >= currentDate;
      });
      const startDate = item.SeminarDateAndTimes[0]?.Date?.split("T")[0];
      const endDate = item.SeminarDateAndTimes[item.SeminarDateAndTimes.length - 1]?.Date?.split("T")[0]; 
      item.SeminarDate = validDate
        ? `${startDate} - <br>${endDate}`
        : startDate;
  
      })
      state.seminars = payload;
    },
    SetFiltersOptionsData(state: any, payload: any) {
      state.filterOptionsData = payload;
    },
  },
};
